import { useEffect } from "react";
import { absoluteURL, shareImageURL, type RouteDefinition } from "../config/site";

function setMeta(selector: string, attribute: string, value: string) {
  const element = document.head.querySelector<HTMLMetaElement>(selector);
  element?.setAttribute(attribute, value);
}

export function useRouteMetadata(route: RouteDefinition | undefined) {
  useEffect(() => {
    if (!route) return;
    const canonical = absoluteURL(route.path);
    const alternate = absoluteURL(route.alternatePath);
    const english = route.language === "en" ? canonical : alternate;
    const turkish = route.language === "tr" ? canonical : alternate;

    document.documentElement.lang = route.language;
    document.title = route.title;
    setMeta("[data-site-description]", "content", route.description);
    setMeta("[data-site-og-title]", "content", route.title);
    setMeta("[data-site-og-description]", "content", route.description);
    setMeta("[data-site-og-url]", "content", canonical);
    setMeta("[data-site-og-locale]", "content", route.language === "tr" ? "tr_TR" : "en_US");
    setMeta("[data-site-og-locale-alternate]", "content", route.language === "tr" ? "en_US" : "tr_TR");
    setMeta("[data-site-og-image]", "content", shareImageURL);
    setMeta("[data-site-og-image-alt]", "content", route.imageAlt);
    setMeta("[data-site-twitter-title]", "content", route.title);
    setMeta("[data-site-twitter-description]", "content", route.description);
    setMeta("[data-site-twitter-image]", "content", shareImageURL);
    setMeta("[data-site-canonical]", "href", canonical);
    setMeta("[data-site-alternate-en]", "href", english);
    setMeta("[data-site-alternate-tr]", "href", turkish);
    setMeta("[data-site-alternate-default]", "href", english);
  }, [route]);
}
